export default __webpack_public_path__ + "static/media/github.93b5a5d2.png";